import { EListingSource } from '../listings/types';

export enum ECampgroundEventName {
  CAMPGROUND_PAGE_VIEWED = 'Campground Page Viewed',
  CAMPGROUND_SELECTED = 'Campground Selected',
  CAMPGROUND_MODULE_INTERACTED = 'Campground Module Interacted',
}

interface ISubcategoryReviews {
  communicationScore?: number;
  cleanlinessScore?: number;
  mechanicalScore?: number;
  valueScore?: number;
  listingAccuracyScore?: number;
}
export interface ICampgroundViewed {
  isFromSignaturePage: boolean;
  isClaimed: boolean;
  previousPageUrl: string | null;
  campgroundID: number;
  campgroundName: string;
  subcategoryReviews: ISubcategoryReviews | null;
  reviewsCount: number | null;
  reviewsAverage: number | null;
  numberOfCategories: number | null;
  numberOfSites: number | null;
  campgroundCity: string;
  campgroundState: string;
  departureDate: number | null;
  returnDate: number | null;
  totalNights: number | null;
  source: EListingSource;
  flexibleDateRange: string | null;
  isOutdoorsyDestination: boolean;
  odnID: string | undefined;
  campgroundCheckInTime: string | undefined;
  campgroundCheckOutTime: string | undefined;
  isCampground: boolean;
  campgroundAddress: string;
}
